import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Container, Nav, Navbar, Dropdown } from 'react-bootstrap'; // Import Dropdown
import { Link } from 'react-router-dom';
import useAuth from '../../../Hooks/useAuth';
import logo from '../../../Images/logo.png';
import './Header.css';

const Header = () => {

    const { user, logout } = useAuth();

    return (
        <div className="head-bg">

            <Navbar className="navbar" collapseOnSelect expand="lg">

                <Container className="container-head">

                    <Navbar.Brand href="/" ><img src={logo} /></Navbar.Brand>

                    <Navbar.Toggle aria-controls="basic-navbar-nav" expand="lg" />

                    <Navbar.Collapse id="basic-navbar-nav">

                        <Nav className="ms-auto align-items-center">

                            <Link to="/home" className='list-item text-decoration-none'>Home</Link>

                            <Link to="/about" className='list-item text-decoration-none'>About</Link>

                            {/* Service Dropdown */}
                            <Dropdown>
                                <Dropdown.Toggle variant="link" id="service-dropdown" className='list-item text-decoration-none'>
                                    Department
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>Pediatrician</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>Orthopedic Specialist</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>Nose, Ear, Throat Specialist</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>Gynaecologist</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>PSYCHIATRIST </Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>Dermatologist</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>Nephrologist</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>Gastroenterologist </Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>Neurologist</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>General Surgery</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>Orthopedic Surgery</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>Laparoscopic surgery</Dropdown.Item>

                                </Dropdown.Menu>
                            </Dropdown>



                            <Dropdown>
                                <Dropdown.Toggle variant="link" id="service-dropdown" className='list-item text-decoration-none'>
                                    Facilities
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>•I.C.U.</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>•N.I.C.U.</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>Ventilator </Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>X.Ray</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>pathology</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>E.C.G.</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>Endoscopy</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>Medical store</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>Ultrasound</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>Ambulance</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/" className='text-decoration-none'>Operation theater</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>

                            <Link to="/contact" className='list-item text-decoration-none'>Contact</Link>
                            {/* {user.email 
                            ?
                            <button type="button" className="btn btn-danger" onClick={logout}>Log Out</button>
                            :
                            <Link to="/login" type="button" className="btn btn-danger">Login</Link>
                            }
                            {user.email &&
                                <Navbar.Text><FontAwesomeIcon icon={faUser} /><span className="userName">{user.displayName}</span></Navbar.Text>
                            } */}

                            <Link to="/Gallery" className='list-item text-decoration-none'>Gallery</Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
};

export default Header;
